import Vue from 'vue'
import Router from 'vue-router'
import Layout from 'views/Layout'
import Login from 'views/Login'
// import Home from 'views/Home'
import HelloWorld from 'views/HelloWorld'
import Department from 'views/Department'
import Region from 'views/Region'
import Role from 'views/Role'
import User from 'views/User'
import Report from 'views/Report'

import Resource from 'views/Resource'

import Article from 'views/Article'
import ArticleCategory from 'views/ArticleCategory'
import ArticleNew from 'views/ArticleNew'

import Test from 'views/Test'
import TestResult from 'views/TestResult'
import TestResultDetail from 'views/TestResultDetail'
import TestPaper from 'views/TestPaper'
import TestPaperQuestion from 'views/TestPaperQuestion'

import Question from 'views/Question'
import QuestionNew from 'views/QuestionNew'
import QuestionCategory from 'views/QuestionCategory'

import ResourceCategory from 'views/ResourceCategory'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/',
          name: 'home',
          component: TestResult
        },
        {
          path: '/hello',
          name: 'hello',
          component: HelloWorld
        },
        {
          path: '/resource/list',
          name: 'resource.list',
          component: Resource
        },
        {
          path: '/resource/category',
          name: 'resource.category',
          component: ResourceCategory
        },
        {
          path: '/department/manage',
          name: 'department.manage',
          component: Department
        },
        {
          path: '/region/manage',
          name: 'region.manage',
          component: Region
        },
        {
          path: '/role/manage',
          name: 'role.manage',
          component: Role
        },
        {
          path: '/user/manage',
          name: 'user.manage',
          component: User
        },
        {
          path: '/report/list',
          name: 'reprort.list',
          component: Report
        },
        {
          path: '/article/list',
          name: 'article.list',
          component: Article
        },
        {
          path: '/article/category',
          name: 'article.category',
          component: ArticleCategory
        },
        {
          path: '/article/new',
          name: 'article.new',
          component: ArticleNew
        },
        {
          path: '/test/list',
          name: 'test.list',
          component: Test
        },
        {
          path: '/test/result',
          name: 'test.result',
          component: TestResult
        },
        {
          path: '/test/result/detail',
          name: 'test.result.detail',
          component: TestResultDetail
        },
        {
          path: '/testPaper/list',
          name: 'testPaper.list',
          component: TestPaper
        },
        {
          path: '/testPaper/question',
          name: 'testPaper.question',
          component: TestPaperQuestion
        },
        {
          path: '/question/list',
          name: 'question.list',
          component: Question
        },
        {
          path: '/question/new',
          name: 'question.new',
          component: QuestionNew
        },
        {
          path: '/question/category',
          name: 'question.category',
          component: QuestionCategory
        },
      ]
    },
    {
      path: '*',
      redirect: '/hello'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js